/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui'

const OrangeLine = () => (
  <div
    sx={{
      width: '40px',
      height: '6px',
      backgroundColor: '#ED7A28',
      mt: 3,
      mb: 2,
    }}
  />
)

export default OrangeLine;